module.exports = __webpack_public_path__ + "img/symbol_8.fcc6afa4.png";